import { render, staticRenderFns } from "./RequestCourse.vue?vue&type=template&id=0d7af80c&scoped=true&"
import script from "./RequestCourse.vue?vue&type=script&lang=js&"
export * from "./RequestCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7af80c",
  null
  
)

export default component.exports